const files = require.context('.', true, /\.js$/)
const modules = {}

files.keys().forEach(key => {
  if (key === './index.js') return
  const moduleName = key.split('/').pop()
  modules[moduleName.replace(/(\.\/|\.js)/g, '')] = files(key).default
})

export default modules
